/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions related to self_profile
	- the files imported in src/pages/profile_edit/reducers/index.js
*/

import Analytics from "./util/Analytics";
import { SET_ACTIVE_FORM } from "ducks/edit_details";

export default function profileDetails(state, action) {
	switch (action.type) {
		case SET_ACTIVE_FORM: {
			const { activeForm } = action.payload;

			Analytics.SelfProfile.trackSelectedDetailsSection(activeForm);
			return;
		}

		default: {
			return;
		}
	}
}




// WEBPACK FOOTER //
// ./src/analytics/self_profile.js